module.exports = __webpack_public_path__ + "assets/img/th-584c821e.png";